export const marketEditableTags = [
  "official",
  "unstable",
  "web",
  "high-quality",
  "high-price",
  "open-source",
  "image-generation",
  "multi-modal",
  "fast",
  "english-model",
];

export const modelImages = [
  "gpt35turbo.png",
  "gpt35turbo16k.webp",
  "gpt4.png",
  "gpt432k.webp",
  "gpt4v.png",
  "gpt4dalle.png",
  "claude.png",
  "claude100k.png",
  "stablediffusion.jpeg",
  "llama2.webp",
  "llamacode.webp",
  "dalle.jpeg",
  "midjourney.jpg",
  "newbing.jpg",
  "palm2.webp",
  "gemini.jpeg",
  "chatglm.png",
  "tongyi.png",
  "sparkdesk.jpg",
  "hunyuan.png",
  "360gpt.png",
  "baichuan.png",
  "skylark.jpg",
];

export const marketTags = [...marketEditableTags, "free", "high-context"];
